<template>
    <UOMClass></UOMClass>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const UOMClass = defineAsyncComponent(() =>
    import("../../../components/Purchasing/UOM/UOMClass.vue")
);
export default {
    components: { UOMClass, AuthLayout },
};
</script>
